<!-- eslint-disable max-lines -->
<template>
    <paper>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :optionNum="optionNum"
            :loading="loading"
            :searchTotalTitle="searchTotalTitle"
            @saveData="saveData"
            @row-db-click="rowDBclick"
            @getTableConfigList="getTableConfigList"
            @check-btn="checkBtn"
            @edit-btn="editBtn"
            @del-btn="delBtn"
            @switch-change="switchChange"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            searchId="test"
            pageID="test"
        >
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" reportCode="REPORT_OTP_ORDER_EXCEPTION">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'07010003'">
                        <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
                <!-- <el-tooltip class="item"
                            effect="dark"
                            content="新增"
                            placement="bottom">
                    <el-button size="mini"
                               icon='el-icon-plus'
                               @click="addData"></el-button>
                </el-tooltip>-->
            </div>
            <div slot="page-module-btn">
                <span v-has="'otp07010001'"><el-button type="primary" @click="orderHandle">处 理</el-button></span>
                <span style="margin-left: 15px;" v-has="'otp07010002'"><el-button type="primary" @click="orderClose">关 闭</el-button></span>
            </div>
        </m-pane>
    </paper>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import mPane from '@/components/otpPanel';
import config from './config.json';
import paper from '@/components/core/paper/Paper';
import reportExport from '@/components/lots/reportExportPlugin';
import { getOrderExceptions, closes, orderExceptionsHandles, getTotalCounts } from '../../../api/orderException';
import { dateTimes, dateTime } from '../../../judge/configCenter';
import { mapState } from 'vuex';

export default {
    name: 'orderException',
    components: { mPane, paper, reportExport },
    data() {
        return {
            config: config,
            loading: false,
            optionNum: '',
            totalData: [],
            pageTotal: 0,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                orderBy: 'create_time',
                orderByType: 'desc',
                exceptionStatus: 10
            },
            searchTotalTitle: config.searchTotalTitle,
            exportParams: {},
            isFirstSearch: true
        };
    },
    methods: {
        _validateSearchParams() {
            const startTime = this.searchParams.createStartTime || 0;
            const endTime = this.searchParams.createEndTime || 0;
            const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            if (!this.searchParams.orderNo && !startTime) {
                return '订单号 和 创建时间 不可同时为空';
            } else if (!this.searchParams.orderNo && startTime) {
                if (timeDifference > 63 * 24 * 60 * 60 * 1000) {
                    return '按时间查询时，查询/导出 时间跨度不可超过两个月！';
                }
            }
        },
        async fetchData(searchCountFlag) {
            if (this._validateSearchParams()) return this.$message.warning(this._validateSearchParams());
            this.isFirstSearch = false;
            const res = await getOrderExceptions(this.searchParams);
            if (res) {
                if (
                    res.data.totalPage !== 0 &&
                    this.searchParams.pageNo > res.data.totalPage
                ) {
                    this.searchParams.pageNo = res.data.totalPage;
                    this.fetchData();
                } else {
                    const list = res.data.list || [];
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].exceptionStatus === '20' || list[i].exceptionStatus === '99') {
                            list[i].timeInterval = this.intervalTime(list[i].createTime, list[i].updateTime);
                        } else {
                            list[i].timeInterval = this.intervalTime(list[i].createTime, dateTime());
                        }
                    }
                    this.totalData = list;
                    if (!searchCountFlag) { this.getPageTotal(); }
                }
            } else {
                this.totalData = [];
            }
        },
        async getPageTotal() {
            const totalCountRes = await getTotalCounts(this.searchParams);
            this.pageTotal = totalCountRes ? totalCountRes.data : 10000;
        },
        rowDBclick(row) {
            // 表格内双击事件
        },
        checkBtn(data) {
            // 表格内按钮查看事件;
        },
        editBtn(data) {
            // 表格内按钮修改事件;
        },
        delBtn(data) {
            // 表格内按钮删除事件;
        },
        selectChange(data) {
            // 表格内选择变化
            this.selectData = data;
        },
        switchChange(data) {
            // 表格内switch切换事件
        },
        searchChange(data) {
            // 提交搜索框
            let createStartTime, createEndTime;
            if (data.createTime && data.createTime.length) {
                createStartTime = dateTimes(data.createTime[0]);
                createEndTime = dateTimes(data.createTime[1]);
            }
            delete data.createTime;

            this.searchParams = {
                ...this.searchParams,
                ...data,
                createStartTime,
                createEndTime,
                pageNo: 1
            };
            this.exportParams = { ...this.searchParams };
            this.fetchData();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.fetchData(true);
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.fetchData(true);
        },
        addData() {
            // 表格新增方法
            this.$refs.tablePage.$refs.table.addData();
        },
        saveData(data) {
            // 表格新增修改后返回数据
        },
        redomet(data) {
            // 这是删除方法
        },
        getTableConfigList(data) {},
        refresh() {
            // 表格内刷新按钮
        },
        // 关闭
        orderClose() {
            const ids = [];
            for (let i = 0; i < this.selectData.length; i++) {
                ids.push(this.selectData[i].id);
            }
            closes(ids).then(res => {
                if (res.code === '0') {
                    this.$message.success('关闭成功！');
                    this.fetchData();
                }
            });
        },
        // 计算时间差
        intervalTime(startTime, endTime) {
            var date1 = new Date(startTime.replace(/-/g, '/'));
            var date2 = new Date(endTime.replace(/-/g, '/'));
            var date3 = date2.getTime() - date1.getTime();
            // 计算出相差天数
            var days = Math.floor(date3 / (24 * 3600 * 1000));
            // 计算出小时数

            var leave1 = date3 % (24 * 3600 * 1000);
            var hours = Math.floor(leave1 / (3600 * 1000));
            // 计算相差分钟数
            var leave2 = leave1 % (3600 * 1000);
            var minutes = Math.floor(leave2 / (60 * 1000));
            // 计算相差秒数
            var leave3 = leave2 % (60 * 1000);
            var seconds = Math.round(leave3 / 1000);
            return (days + '天 ' + hours + '小时 ' + minutes + '分钟 ' + seconds + '秒');
        },
        // 处理
        orderHandle() {
            const ids = [];
            for (let i = 0; i < this.selectData.length; i++) {
                ids.push(this.selectData[i].id);
            }
            orderExceptionsHandles(ids).then(res => {
                if (res.code === '0') {
                    this.$message.success('处理完成！');
                    this.fetchData();
                }
            });
        },
        // 导出
        exportFile(submit) {
            const isFirstSearch = this.isFirstSearch;
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (this._validateSearchParams()) return isFirstSearch ? false : this.$message.warning(this._validateSearchParams());
            submit({ ...this.exportParams, tenantCode: this.currentTenant.tenantCode });
            this.isFirstSearch = false;
        }
    },
    mounted() {
        this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    computed: {
        ...mapState({
            currentTenant: state => state.currentTenant
        })
    }
};
</script>
